// Module
var code = "<div class=\"card card-default on-dashboard\"> <div class=\"card-header\" data-translate>dashboard.userUsage.HEADER</div> <div class=\"card-body\"> <div data-vngage-user-usage data-ng-model=\"userUsage.statistics\"></div> <div data-vngage-spinner data-spin=\"userUsage.loading\"></div> </div> </div> ";
// Exports
var _module_exports =code;;
var path = 'app/dashboard/userUsage/UserUsageTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;